import _ from 'lodash';

import React from 'react';
import {connect} from 'react-redux';
import {isSubmitting, formValueSelector} from 'redux-form';

import {default as Modal, withModal} from 'components/Modal';
import {Buttons, AssignRoomPurposeForm} from './components';

import {MODALS} from 'ducks/allocations';
import {PERMISSIONS, requiresPermission} from 'ducks/auth';
import {openModal} from 'ducks/modals';

import './styles.css';

class AssignRoomPurposeModal extends React.Component<any> {
  openConfirmAssignRoomPurposeModal = selectedRooms => {
    const {locationRef, roomsForRoomPurposesDashboard} = this.props;

    this.props.requiresPermission(
      {
        locationRef,
        permission: PERMISSIONS.CREATE_ROOM_PURPOSES
      },
      () =>
        this.props.openModal(MODALS.CONFIRM_ASSIGN_ROOM_PURPOSE, {
          locationRef,
          selectedRooms,
          roomsForRoomPurposesDashboard
        })
    );
  };
  render() {
    const {
      selectedRoomsIds,
      roomsForRoomPurposesDashboard,
      form: {submitting, roomPurpose, startDate}
    } = this.props;

    const selectedRooms = roomsForRoomPurposesDashboard.filter((room: any) =>
      _.includes(selectedRoomsIds, room.roomId)
    );

    const disableSwitchingToConfirm = !roomPurpose || !startDate;

    return (
      <Modal
        show={true}
        type={Modal.SMALL}
        onClose={this.props.closeModal}
        className="AssignRoomPurposeModal">
        <Modal.Header heading="Assign RoomPurpose" />
        <Modal.Body>
          <div className="AssignRoomPurposeModal__container">
            <AssignRoomPurposeForm
              roomsForRoomPurposesDashboard={roomsForRoomPurposesDashboard}
              extraActions={this.props.extraActions}
              locationRef={this.props.locationRef}
              selectedRoomsIds={selectedRoomsIds}
              selectedRooms={selectedRooms}
              selectRoom={this.props.selectRoom}
              deselectNumberOfRooms={this.props.deselectNumberOfRooms}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Buttons
            triggerSubmit={() =>
              this.openConfirmAssignRoomPurposeModal(selectedRooms)
            }
            submitting={submitting}
            onClose={this.props.closeModal}
            disabled={disableSwitchingToConfirm}
          />
        </Modal.Footer>
      </Modal>
    );
  }
}
const formSelector = formValueSelector('assignRoomPurpose');

const mapStateToProps = state => ({
  form: {
    submitting: isSubmitting('assignRoomPurpose')(state),
    roomPurpose: formSelector(state, 'roomPurpose'),
    startDate: formSelector(state, 'startDate')
  }
});

const mapDispatchToProps = {
  requiresPermission,
  openModal
};

export default connect(mapStateToProps, mapDispatchToProps)(
  withModal(MODALS.ASSIGN_ROOM_PURPOSE)(AssignRoomPurposeModal)
);
